import { SET_INVOICE, SET_LOADING } from 'redux/actions/types';
import apiService from '../../utils/ApiService';

const { billerService } = apiService.getInstance();

export const setLoading = isLoading => ({
  type: SET_LOADING,
  payload: isLoading,
});

export const setInvoice = data => ({
  type: SET_INVOICE,
  payload: data,
});

export const getInvoice = id => async dispatch => {
  let resolve = null;
  try {
    const response = await billerService.get(`orders/${id}/invoices`);
    resolve = response;
    if (response.status === 200) {
      const { payload } = response.data;
      resolve = Promise.resolve(payload);
      dispatch(setInvoice(payload[0]));
    } else {
      dispatch(setInvoice({}));
      resolve = Promise.reject(response);
    }
  } catch (error) {
    resolve = Promise.reject(error);
    dispatch(setInvoice({}));
  }
  return resolve;
};
